import {
  Alert as MuiAlert,
  type AlertColor as MuiAlertColor,
  type AlertProps as MuiAlertProps,
  AlertTitle as MuiAlertTitle,
  type AlertTitleProps as MuiAlertTitleProps
} from "@mui/material";

export type AlertProps = MuiAlertProps;
export type AlertTitleProps = MuiAlertTitleProps;
export type AlertColor = MuiAlertColor;

export const Alert = MuiAlert;
export const AlertTitle = MuiAlertTitle;
